// Oylan stand: "Где ошибка?" after a wrong answer.
//
// A step from oylan/build_content.py carries oylanMistakes (typical wrong answer -> which
// step of the reasoning went wrong) and oylanCheck (a check by substitution, "{x}" is the
// child's answer). Both are checked by the builder not to contain the right answer, so
// the explanation points at the mistake and never gives the answer away.

// For a number task the single number in the answer counts ("1,5 кг" -> "1,5", "3 шара" -> "3");
// "1.5" and "1,5" are the same answer, keys in oylanMistakes use the comma.
export function normalizeAttempt(attempt, expectedAnswers) {
    const text = String(attempt ?? "").trim().toLowerCase();
    if (!expectedAnswers.every((a) => /^\d+$/.test(String(a).trim()))) return text;
    const numbers = text.match(/\d+(?:[.,]\d+)?/g);
    return numbers && numbers.length === 1 ? numbers[0].replace(".", ",") : text;
}

// Returns null when the step has no diagnosis (then the button is not shown).
export function diagnose(attempt, step) {
    const { oylanMistakes, oylanCheck, stepAnswer = [] } = step || {};
    if (!oylanCheck) return null;
    const key = normalizeAttempt(attempt, stepAnswer);
    const known = Object.entries(oylanMistakes || {}).find(([wrong]) => wrong.toLowerCase() === key);
    if (known) return known[1];
    return oylanCheck.split("{x}").join(String(attempt).trim());
}
